// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"cc177832","498":"465553d6","558":"a5b46a79","630":"d9ec04cb","725":"49dd62df","738":"4e45d81f","787":"6ef58620","912":"ecdafd93"}[chunkId] + ".chunk.js";
};